__turbopack_context__.v({
  "creators": "Hero-module-scss-module__lxDNyq__creators",
  "fade-in": "Hero-module-scss-module__lxDNyq__fade-in",
});
